export default __webpack_public_path__ + "static/media/codemanBD.51fac14a.png";